import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import BadgeStyle from "components/badges/Badge.module.scss";

export const Ruby = ({size, id, className}) => {
  let _attributes = {};
  _attributes.viewBox = "0 0 64 64";
  _attributes.width = _attributes.height = size || 64;
  if (id.trim() !== "") _attributes.id = id;
  if (className) {
    _attributes.className = classnames(BadgeStyle["badge"], className);
  } else {
    _attributes.className = BadgeStyle["badge"];
  }

  return (
    <svg {..._attributes}>
      <rect x={0} y={0} width={64} height={64} className={BadgeStyle["badge__canvas"]}/>
      <g>
        <g>
          <path d="M32.003,12.314l-23.998,-4.315l5.502,4.315l18.496,0Z" className={BadgeStyle["ruby__fill1"]} />
          <path d="M13.507,12.314l-5.502,-4.315l10.33,23.998l-4.828,-19.683Z" className={BadgeStyle["ruby__fill2"]} />
          <path d="M56,7.999l-47.995,0l23.998,4.315l23.997,-4.315Z" className={BadgeStyle["ruby__fill2"]} />
          <path d="M18.337,31.997l-10.331,-23.998l11.775,47.995l-1.444,-23.997Z" className={BadgeStyle["ruby__fill1"]} />
          <path d="M32.003,12.314l18.496,0l5.501,-4.315l-23.997,4.315l0,0Z" className={BadgeStyle["ruby__fill1"]} />
          <path d="M50.499,12.314l-4.831,19.683l10.33,-23.998l-5.502,4.315l0.003,0Z" className={BadgeStyle["ruby__fill3"]} />
          <path d="M40.841,51.677l3.384,4.315l1.445,-23.998l-4.829,19.683Z" className={BadgeStyle["ruby__fill3"]} />
          <path d="M45.67,31.997l-1.444,23.997l11.774,-47.995l-10.33,23.998Z" className={BadgeStyle["ruby__fill4"]} />
          <path d="M32.003,51.679l12.223,4.315l-3.385,-4.315l-8.838,0Z" className={BadgeStyle["ruby__fill5"]} />
          <path d="M23.164,51.679l-3.384,4.315l12.223,-4.315l-8.839,0Z" className={BadgeStyle["ruby__fill3"]} />
          <path d="M19.78,55.994l24.446,0l-12.223,-4.315l-12.223,4.315Z" className={BadgeStyle["ruby__fill4"]} />
          <path d="M23.166,51.677l-4.831,-19.678l1.445,23.998l3.386,-4.32Z" className={BadgeStyle["ruby__fill4"]} />
          <path d="M32.003,12.314l-18.496,0l5.501,4.315l12.995,-4.315Z" className={BadgeStyle["ruby__fill2"]} />
          <path d="M18.335,31.997l8.213,15.367l-7.54,-30.735l-0.673,15.368Z" className={BadgeStyle["ruby__fill5"]} />
          <path d="M44.997,16.629l-12.994,-4.314l-12.994,4.314l25.988,0Z" className={BadgeStyle["ruby__fill1"]} />
          <path d="M45.67,31.997l-0.673,-15.368l-7.54,30.735l8.213,-15.367Z" className={BadgeStyle["ruby__fill6"]} />
          <path d="M19.008,16.629l-5.501,-4.314l4.828,19.682l0.673,-15.368Z" className={BadgeStyle["ruby__fill1"]} />
          <path d="M50.499,12.314l-18.496,0l12.994,4.315l5.502,-4.315Z" className={BadgeStyle["ruby__fill6"]} />
          <path d="M37.457,47.364l3.386,4.313l4.829,-19.683l-8.215,15.37Z" className={BadgeStyle["ruby__fill4"]} />
          <path d="M32.003,51.679l8.838,0l-3.384,-4.314l-5.454,4.314Z" className={BadgeStyle["ruby__fill6"]} />
          <path d="M26.55,47.364l5.455,4.315l5.455,-4.315l-10.91,0Z" className={BadgeStyle["ruby__fill3"]} />
          <path d="M50.499,12.314l-5.502,4.315l0.673,15.367l4.829,-19.682l0,0Z" className={BadgeStyle["ruby__fill5"]} />
          <path d="M18.335,31.999l4.831,19.678l3.384,-4.315l-8.215,-15.363Z" className={BadgeStyle["ruby__fill3"]} />
          <path d="M23.163,51.679l8.839,0l-5.455,-4.314l-3.384,4.314Z" className={BadgeStyle["ruby__fill4"]} />
          <path d="M23.61,35.387l2.939,11.977l10.909,0l4.767,-19.449c-4.051,6.026 -11.218,9.737 -18.615,7.472Z" className={BadgeStyle["ruby__fill1"]} />
          <path d="M19.009,16.629l4.601,18.759c7.397,2.265 14.565,-1.447 18.619,-7.473l2.769,-11.286l-25.989,0Z" className={BadgeStyle["ruby__fill2"]} />
        </g>
        <path d="M19.565,17.838l6.795,-0.646l-6.795,-0.645l-0.645,-6.795l-0.646,6.795l-6.795,0.646l6.795,0.645l0.646,6.795l0.645,-6.795Z" className={BadgeStyle["ruby__white"]} />
        <path d="M37.319,47.872l2.923,-0.278l-2.923,-0.278l-0.278,-2.923l-0.278,2.923l-2.923,0.278l2.923,0.278l0.278,2.923l0.278,-2.923Z" className={BadgeStyle["ruby__white"]} />
        <path d="M49.595,12.209l2.924,-0.278l-2.924,-0.277l-0.278,-2.924l-0.277,2.924l-2.924,0.277l2.924,0.278l0.277,2.924l0.278,-2.924Z" className={BadgeStyle["ruby__white"]} />
      </g>
    </svg>
  );
};

Ruby.defaultProps = {
  size: 64,
  className: "",
  id: ""
};

Ruby.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  id: PropTypes.string
};
